import styled from 'styled-components';

import { LoadingButton } from 'components/button/LoadingButton';

type SInformationItemProps = {
  $invisibleBorderBottom?: boolean;
};

export const SInformationItem = styled.div<SInformationItemProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid
    ${({ theme, $invisibleBorderBottom }) => ($invisibleBorderBottom ? 'none' : theme.color.line.line_2)};

  ${({ theme }) => theme.font.body1_m};
  color: ${({ theme }) => theme.color.text.TXT_2};

  @media ${({ theme }) => theme.device.large} {
    ${({ theme }) => theme.font.body2_m};
  }

  span {
    height: ${({ theme }) => theme.font.body1_sb.lineHeight};
    display: inline-flex;
    align-items: center;
  }

  .bold {
    ${({ theme }) => theme.font.body1_sb};
    color: ${({ theme }) => theme.color.text.TXT_4};

    @media ${({ theme }) => theme.device.large} {
      ${({ theme }) => theme.font.body2_sb};
    }
  }

  .blur {
    filter: blur(5px);
  }
`;

export const SAdditionalInformation = styled.div`
  ${({ theme }) => theme.font.caption1_m};
  color: ${({ theme }) => theme.color.text.TXT_1};
  display: flex;
  align-items: center;
  margin-top: 4px;

  span {
    margin-left: auto;
  }
`;

type SVerificationButtonProps = {
  disabled: boolean;
};
export const SVerificationButton = styled(LoadingButton)<SVerificationButtonProps>`
  padding: 6px 16px;
  border-radius: 8px;
  text-align: center;
  border: 1px solid ${({ theme }) => theme.color.line.line_3};
  background-color: ${({ theme, disabled }) => (disabled ? theme.palette.neutral[15] : 'transparent')};
  color: ${({ theme, disabled }) => (disabled ? theme.color.text.TXT_0 : theme.color.text.TXT_3)};
  ${({ theme }) => theme.font.body3_m};
`;

export const SModificationButton = styled(LoadingButton)`
  padding: 6px 16px;
  border-radius: 8px;
  text-align: center;
  border: 1px solid ${({ theme }) => theme.color.line.line_3};
  background-color: transparent;
  color: ${({ theme }) => theme.color.text.TXT_3};
  ${({ theme }) => theme.font.body3_m};
`;
